import React from 'react';
import {motion} from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/sections/Hero';
import ClientTrustBar from './components/sections/ClientTrustBar';
import ValueProposition from './components/sections/ValueProposition';
import ServicesShowcase from './components/sections/ServicesShowcase';
import CaseStudies from './components/sections/CaseStudies';
import Framework from './components/sections/Framework';
import FounderNote from './components/sections/FounderNote';
import Testimonials from './components/sections/Testimonials';
import Pricing from './components/sections/Pricing';
import Team from './components/sections/Team';
import FinalCTA from './components/sections/FinalCTA';
import Footer from './components/Footer';
import TrafftModal from './components/TrafftModal';
import {useTrafftModal} from './hooks/useTrafftModal';
import './App.css';

function App() {
  const {isOpen, openTrafftModal, closeTrafftModal} = useTrafftModal();

  return (
    <div className="App">
      <Navbar onScheduleCall={openTrafftModal} />
      <Hero onScheduleCall={openTrafftModal} />
      <ClientTrustBar />
      <ValueProposition />
      <ServicesShowcase />
      <CaseStudies />
      <Framework />
      <FounderNote />
      {/* <Testimonials /> */}
      <Pricing onScheduleCall={openTrafftModal} />
      <Team />
      <FinalCTA onScheduleCall={openTrafftModal} />
      <Footer onScheduleCall={openTrafftModal} />
      <TrafftModal isOpen={isOpen} onClose={closeTrafftModal} />
    </div>
  );
}

export default App;